import {flatten, isEmpty, sortBy, startCase, values} from "lodash";
import {parseBulletText} from "../../logic/products";
import React from "react";

export default function ToolProductInfo({product}) {
  if (isEmpty(product)) return null;

  return <div className="pt-2">
    <div className="font-bold">{product.name}</div>
    <div className="">{product.vendorsku}</div>
    <ItemAttrs product={product}/>
    <ItemBullets product={product}/>
  </div>
}

function ItemBullets({product}) {
  const bullets = parseBulletText(product?.bullets);
  if (isEmpty(bullets)) return null;

  return <ul>
    {bullets.map((b, i) => <li className="text-gray-600" key={i}>{b}</li>)}
  </ul>
}

function ItemAttrs({product}) {
  const {qualities} = product;
  if (!qualities) return null;

  const list = sortBy(flatten(values(qualities)), x => x.name);

  return <ul>
    {list.map((attr, i) => <li key={attr.name}>
      <strong>{startCase(attr.name)}: </strong>
      {' ' + attr.value}
    </li>)}
  </ul>

}
